import { render, staticRenderFns } from "./ReleasesView.vue?vue&type=template&id=e2fb7a9a"
import script from "./ReleasesView.vue?vue&type=script&lang=js"
export * from "./ReleasesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports